import { monolithHttpClient } from 'src/editor/api/http-clients/monolith-http-client'

export const fetchPaymentData = pageId => {
  return monolithHttpClient.get(`/sales/${pageId}/page/data/product`)
}

export const fetchOfferData = pageId => {
  return monolithHttpClient.get(`/page/${pageId}/offer/data`)
}
